<template>
  <TwnBaseBtn
    :icon="icon"
    :severity="severity"
    :size="size"
    :variant="variant"
    aria-label="toggle-menu"
    data-mobile-menu-toggle
    class="cursor-pointer"
    @click="handleToggle"
  />
</template>

<script lang="ts" setup>
import TwnBaseBtn from '@/components/atoms/buttons/twn-base-btn/TwnBaseBtn.vue'
import {
  TwnMobileMenuToggleEmits,
  TwnMobileMenuToggleProps
} from '@/domains/admin-panel/components/molecules/menu/twn-mobile-menu-toggle/TwnMobileMenuToggle.types'
import { useMenuStore } from '@/domains/admin-panel/store/use-menu-store/useMenuStore'

// Props with defaults
withDefaults(defineProps<TwnMobileMenuToggleProps>(), {
  icon: 'grid_view',
  severity: 'secondary',
  size: 'small',
  variant: 'outlined'
})

// Emits
const emit = defineEmits<TwnMobileMenuToggleEmits>()

const menuStore = useMenuStore()

// Methods
const handleToggle = () => {
  menuStore.toggleMobileMenu()
  emit('toggle')
}
</script>
